import { LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAILURE } from "../../Actions/types";

const initialState = {
  loading: false,
  error: null,
  data: null,
};
function logoutReducer(state = initialState, action) {
  switch (action.type) {
    case LOGOUT:
      return state;
    case LOGOUT_SUCCESS:
      return { ...state, data: action?.payload };
    case LOGOUT_FAILURE:
      return { ...state, data: action?.payload };

    default:
      return state;
  }
}

export default logoutReducer;
